// extracted by mini-css-extract-plugin
export default {"paymentContainer":"style_paymentContainer__se-bd","wrapper":"style_wrapper__KOI6L","noData":"style_noData__H+EKc"};